module.exports = __webpack_public_path__ + "static/img/reward_block_bg.52d528b6.svg";